var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StudyDates flex items-center"},[_c('div',{staticClass:"text-neutral-01 text-sm font-semibold leading-4",attrs:{"data-e2e":"studyDates"}},[_vm._v(" "+_vm._s(_vm.$t('conversation_date'))+": "+_vm._s(_vm.dates)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }